export const userSettingKeys = [
  "frontendChannel",
  "sendActivityEmail",
  "inactivityLogoutMinutes",
  "debugMode",
  "dataRetentionDays",
  "backendChannel",
  "customServerUrl",
  "scenarioDocumentsFeature",
  "availableVoiceProviders",
  "availableRatings",
  "availableAgentProviders",
  "ephemeralSessions",
  "sessionTimeoutSeconds",
  "conversationIdleTimeSeconds",
  "agentTemperature",
  "agentMaxResponseTokens",
  "agentUserCanInterrupt",
  "transcriberSegmentationSilenceTimeoutMs",
  "transcriberInitialSilenceTimeoutMs",
];

export const organizationSettingKeys = [
  "sendActivityEmail",
  "inactivityLogoutMinutes",
  "debugMode",
  "backupServerRatio",
  "backendChannel",
  "customServerUrl",
  "askChatConsent",
  "dataRetentionDays",
  "appLogo",
  "appName",
  "scenarioDocumentsFeature",
  "scenarioDocumentCrawlingFeature",
  "scenarioDocumentsPipeline",
  "stepScenarioFeature",
  "supportBotFeature",
  "webAvatarFeature",
  "scenarioWizardFeature",
  "multilingualScenarioFeature",
  "enableTranslateCopy",
  "availableVoiceProviders",
  "availableRatings",
  "availableAgentProviders",
  "agentTools",
  "goalScoringModifier",
  "ephemeralSessions",
  "sessionTimeoutSeconds",
  "conversationIdleTimeSeconds",
  "agentTemperature",
  "agentMaxResponseTokens",
  "agentUserCanInterrupt",
  "transcriberProvider",
  "transcriberSegmentationSilenceTimeoutMs",
  "transcriberInitialSilenceTimeoutMs",
  "chatInputVisibility",
  "chatLogVisibility",
];

export const allTurnTakingSettingKeys = [
  "turnTakingStrategy",
  "vadConfidence",
  "vadStartSecs",
  "minWordsForInterruption",
  "turnStopTimeout",
  "turnTakeDelay",
  "vadStopSecs",
  "smartTurnStopSecs",
  "smartTurnPreSpeechMs",
  "userSpeechTimeout",
];

export const scenarioBaseSettingKeys = [
  "agentProvider",
  "assessmentMode",
  "backupServerRatio",
  "goalScoringModifier",
  "availableRatings",
  "webAvatarFeature",
  "backendChannel",
  "customServerUrl",
  "multilingualScenarioFeature",
  "scenarioDocumentsPipeline",
  "debugMode",
  "dataRetentionDays",
  "chatInputVisibility",
  "chatLogVisibility",
  "askChatConsent",
  "transportType",
  "showSlidesFromStart",
  "ephemeralSessions",
  "sessionTimeoutSeconds",
  "conversationIdleTimeSeconds",
  "agentModelName",
  "agentTools",
  "agentTemperature",
  "agentMaxResponseTokens",
  "agentUserCanInterrupt",
  "agentRichTextOutput",
  "agentAllowEmojiOutput",
  "agentArtificialDelay",
  "transcriberProvider",
  "transcriberWaitForHumanContinuingSeconds",
  "transcriberSegmentationSilenceTimeoutMs",
  "transcriberInitialSilenceTimeoutMs",
  "sessionSummaryPrompt",
];

export const getScenarioSettingKeys = (turnTakingStrategy, turnTakeDelay) => {
  const isManual = turnTakeDelay === "manual";
  const isSmart = turnTakingStrategy === "smart";
  const isTranscription = turnTakingStrategy === "transcription";

  const turnTakingKeys = [
    "turnTakingStrategy",
    "vadConfidence",
    "vadStartSecs",
    "minWordsForInterruption",
    "turnStopTimeout",
  ];

  if (!isTranscription) turnTakingKeys.push("turnTakeDelay");
  if (!isSmart && !isTranscription && isManual) turnTakingKeys.push("vadStopSecs");
  if (isSmart && isManual) turnTakingKeys.push("smartTurnStopSecs");
  if (isSmart) turnTakingKeys.push("smartTurnPreSpeechMs");
  if (isTranscription) turnTakingKeys.push("userSpeechTimeout");

  return [...scenarioBaseSettingKeys, ...turnTakingKeys];
};

const sessionOnlySettingKeys = ["disableTextInput", "synthesizerProvider", "synthesizerVoice"];

export const sessionSettingsKeys = [
  ...new Set([
    ...scenarioBaseSettingKeys,
    ...allTurnTakingSettingKeys,
    ...organizationSettingKeys,
    ...userSettingKeys,
    ...sessionOnlySettingKeys,
  ]),
];
